import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Telco} from "./telco";

@Injectable()
export class TelcoService {

	private url: string = "http://localhost:8080/ddmfBlackList/";
	// private dataJson: string = "";

	constructor(private http: Http) { }

	myTelcoCredits(){
		return this.http.get(this.getUserUrl('myTelcoCredits/?userId='))
			.map(res => res.json());
		// return this.dataJson = [
		// 	{ "blackListId": "12", "icNo": "123456", "newIcNo": "985632", "brNo": "586231", "name": "maxis", "accountNo": "ac485622", "dateOfBirth": "12/4/89", "remarks": "payments is pending" },
		// 	{ "blackListId": "12", "icNo": "123456", "newIcNo": "985632", "brNo": "586231", "name": "maxis", "accountNo": "ac485622", "dateOfBirth": "12/4/89", "remarks": "payments is pending" }
		// 	];
	}

	getUser(id){
		return this.http.get(this.getUserUrl(name))
			.map(res => res.json());
	}

	searchTelcoCredits(user){
		return this.http.post(this.getUserUrl('searchTelcoCredits'), JSON.stringify(user))
			.map(res => res.json());
	}

	addTelcoCredits(user){
		return this.http.post(this.getUserUrl('searchTelcoCredits'), JSON.stringify(user))
			.map(res => res.json());
	}

	editTelcoCredits(user){
		return this.http.post(this.getUserUrl('editTelcoCredits'), JSON.stringify(user))
			.map(res => res.json());
	}

	deleteUser(name){
		return this.http.delete(this.getUserUrl(name))
			.map(res => res.json());
	}

	private getUserUrl(name){
		return this.url + "/" + name;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/telco.service.ts